module.exports = __webpack_public_path__ + "img/w3_subset_black.1876c84d.png";